/**
 * Page unifiée du Dashboard - Auto-détection Propriétaire/Locataire
 * Remplace l'ancien OwnerDashboardPage obsolète
 */

import React from 'react';
import { Container, Box } from '@mui/material';
import DashboardUnified from '../components/dashboard/DashboardUnified';

const DashboardUnifiedPage = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box>
        <DashboardUnified />
      </Box>
    </Container>
  );
};

export default DashboardUnifiedPage;
